import { Spine, TextureAtlas, AtlasAttachmentLoader, SkeletonJson } from '@pixi-spine/all-4.1';
import { BaseTexture } from 'pixi.js';

/**
 * Allows custom configuration of the pixi Spine() class, primarily to work around atlas files not being included in vite builds.
 * @param atlas Spine atlas data as a string.
 * @param json Spine JSON as an object.
 * @param image Path to the image file used by the spine atlas
 * @returns A Spine object
 */
export const createSpine = (atlas: string, json: unknown, image: string): Spine => {
  const textureAtlas = new TextureAtlas(atlas, (_line, callback) =>
    callback(BaseTexture.from(image, { pixiIdPrefix: 'spine' }))
  );
  const atlasLoader = new AtlasAttachmentLoader(textureAtlas);
  const skeletonJson = new SkeletonJson(atlasLoader);
  const spineData = skeletonJson.readSkeletonData(json);
  return new Spine(spineData);
};
